import React from 'react';
import { Button } from '../core/Button.jsx';

/**
 * Dialog — Yapp's modal for alerts & confirms (the in-app replacement for
 * window.alert / confirm). Emoji icon by type, centered white card with a
 * slide-up entrance, dark scrim behind. Renders nothing when `open` is false.
 */
export function Dialog({
  open,
  title = 'Yapp',
  message,
  type = 'info',
  confirmText = 'OK',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  children,
}) {
  if (!open) return null;

  const icons = { info: '💬', success: '✅', warning: '⚠️', error: '❌' };

  return (
    <div
      onClick={onCancel || onConfirm}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'var(--surface-overlay)',
        backdropFilter: 'blur(5px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 'var(--space-4)',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 440,
          background: 'var(--surface-card)',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-xl)',
          padding: 'var(--space-8)',
          animation: 'yapperSlideUp 0.3s var(--ease-out)',
        }}
      >
        <style>{`@keyframes yapperSlideUp{from{transform:translateY(40px);opacity:0}to{transform:translateY(0);opacity:1}}`}</style>
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)', marginBottom: 'var(--space-3)' }}>
          <span style={{ fontSize: '1.6rem', lineHeight: 1 }}>{icons[type] || icons.info}</span>
          <h3 style={{ margin: 0, fontSize: 'var(--text-lg)', fontWeight: 'var(--weight-bold)', color: 'var(--text-strong)' }}>{title}</h3>
        </div>

        {message && (
          <p style={{ margin: '0 0 var(--space-6)', fontSize: 'var(--text-base)', lineHeight: 'var(--leading-normal)', color: 'var(--text-body)' }}>{message}</p>
        )}
        {children}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 'var(--space-3)', marginTop: 'var(--space-6)' }}>
          {onCancel && <Button variant="ghost" onClick={onCancel}>{cancelText}</Button>}
          <Button variant={type === 'error' || type === 'warning' ? 'danger' : 'primary'} onClick={onConfirm}>{confirmText}</Button>
        </div>
      </div>
    </div>
  );
}
